// extracted by mini-css-extract-plugin
module.exports = {"imageWrapper":"jA-z","hovered":"kA-z","hoverImage":"lA-z","mainImage":"mA-z","imageNoBackground":"nA-z","fullSizeImage":"oA-z"};